// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:00
import { UserAccessArgs_abstract } from './../../abstract/SagaBase/Defines/UserAccessArgs_abstract';
export class UserAccessArgs extends UserAccessArgs_abstract {}
